// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mobile-header-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.mobile-header-container .mobile-nav-logo-container {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.mobile-header-container .mobile-search-bar-container {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  flex: 1 1 auto;
  padding: 0 10px;
}
.mobile-header-container .mobile-search-bar-container .mat-mdc-form-field-flex {
  padding-bottom: 0 !important;
}

.mobile-header-logo {
  width: 30% !important;
}

#myCarousel {
  display: block;
  position: relative;
  width: 100%;
  height: calc(100vh - 210px);
  margin: auto;
  z-index: 1000000;
  background-color: white;
}

#carousel-container {
  position: absolute;
  background-color: white;
  padding: 50px 20px;
  z-index: 1000000;
  height: 100vh;
  width: 100vw;
}

.carousel-indicators .active {
  margin: 0 10px !important;
}

.carousel-indicators li {
  margin: 0 10px !important;
}

.carousel-inner .item img {
  width: 100%;
  max-width: 100%;
  height: auto;
  display: block;
}

#carrousel-footer div:last-of-type {
  margin-top: 10px;
}
#carrousel-footer div:last-of-type label {
  margin-right: 10px;
}`, "",{"version":3,"sources":["webpack://./src/app/people/components/mobile/people-list/mobile-people-list.component.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;AACJ;AAAI;EACI,aAAA;EACA,2BAAA;EACA,mBAAA;AAER;AAAI;EACI,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;AAER;AADQ;EACI,4BAAA;AAGZ;;AAEA;EACI,qBAAA;AACJ;;AAEA;EACI,cAAA;EACA,kBAAA;EACA,WAAA;EACA,2BAAA;EACA,YAAA;EACA,gBAAA;EACA,uBAAA;AACJ;;AAEA;EACI,kBAAA;EACA,uBAAA;EACA,kBAAA;EACA,gBAAA;EAEA,aAAA;EACA,YAAA;AAAJ;;AAGA;EACI,yBAAA;AAAJ;;AAGA;EACG,yBAAA;AAAH;;AAGA;EACI,WAAA;EACA,eAAA;EACA,YAAA;EACA,cAAA;AAAJ;;AAII;EAII,gBAAA;AAJR;AACQ;EACI,kBAAA;AACZ","sourcesContent":[".mobile-header-container {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    .mobile-nav-logo-container {\n        display: flex;\n        justify-content: flex-start;\n        align-items: center;\n    }\n    .mobile-search-bar-container {\n        display: flex;\n        justify-content: flex-end;\n        align-items: center;\n        flex: 1 1 auto;\n        padding: 0 10px;\n        .mat-mdc-form-field-flex {\n            padding-bottom: 0!important;\n        }\n    }\n}\n\n.mobile-header-logo {\n    width: 30%!important;\n}\n\n#myCarousel {\n    display: block;\n    position: relative;\n    width: 100%;\n    height: calc(100vh - 210px);\n    margin: auto;\n    z-index: 1000000;\n    background-color: white\n}\n\n#carousel-container {\n    position: absolute;\n    background-color: white;\n    padding: 50px 20px;\n    z-index: 1000000;\n   // top: calc(50% - 350px);\n    height: 100vh;\n    width: 100vw;\n}\n\n.carousel-indicators .active {\n    margin: 0 10px!important;\n}\n\n.carousel-indicators li {\n   margin: 0 10px!important;\n}\n\n.carousel-inner .item img {\n    width: 100%;\n    max-width: 100%;\n    height: auto;\n    display: block;\n  }\n\n  #carrousel-footer {\n    div:last-of-type {\n        label {\n            margin-right: 10px;\n        }\n        margin-top: 10px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
